
//#region libraries
import React, { useState } from 'react';
// bootstrap
import Row from 'react-bootstrap/Row';

// custom components
import { Card } from '_atoms';
import { BeaconsSelector } from '_organisms';

import BeaconDetails from '../beacon-details';
//#endregion
const WaitingAreas = (props) => {

    // local states
    const [showBeaconDetails, setShowBeaconDetails] = useState(false)


    return (
        <Row style={{ marginLeft: 2 }}>
            {showBeaconDetails ? <BeaconDetails close={() => { setShowBeaconDetails(false) }} /> :
                <Card>
                    <BeaconsSelector showBeaconDetails={() => { setShowBeaconDetails(true) }} />
                </Card>
            }
        </Row>
    );
};

export default WaitingAreas;
